import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "poap-page__content" }
const _hoisted_2 = { class: "poap-page__profiles" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "poap-page__profile-bg-img" }, null, -1)
const _hoisted_5 = { class: "poap-page__profile-name" }
const _hoisted_6 = { class: "poap-page__profile-social" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "poap-page__profile-social-link-text" }
const _hoisted_10 = ["src"]

import usePoap from '@/components/Poap/usePoap'
import Header from '@/components/Header.vue'
import JoinCommunity from '@/components/Content/JoinCommunity.vue'
import Footer from '@/components/Footer.vue'
import { onMounted, ref, computed } from 'vue'
import usePwnTeamMembers from '@/components/Content/PwnTeamAndAdvisors/usePwnTeamMembers'
type FrontLineProfile = {
  name: string
  profileImg: string
  socials: {
    name: string
    icon: string
    link: string
  }[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PoapPage',
  setup(__props) {

const poapIframeRef = ref<HTMLIFrameElement>()
const { fetchPwnTeamMembers, pwnTeamMembers } = usePwnTeamMembers()
const { activePoap, fetchActivePoap } = usePoap()

onMounted(async () => {
  fetchPwnTeamMembers()
  fetchActivePoap()
})

const getProfileImageByName = (name: string) => {
  const member = pwnTeamMembers.value?.find(member => member.name === name)
  return member?.profileImg?.url || ''
}

const pwnFrontLine = computed<FrontLineProfile[]>(() => [
  {
    name: 'Josef Je',
    socials: [
      {
        name: 'JosefJ_',
        link: 'https://twitter.com/JosefJ_',
        icon: '/poap/twitter.svg',
      },
      {
        name: 'buben42',
        link: 'https://t.me/buben42',
        icon: '/poap/telegram.svg',
      },
      {
        name: 'josef@pwn.xyz',
        link: 'mailto:josef@pwn.xyz',
        icon: '/poap/email.svg',
      },
    ],
    profileImg: getProfileImageByName('Josef Je'),
  },
  {
    name: 'Steve Fau',
    socials: [
      {
        name: 'steve_fau',
        link: 'https://twitter.com/steve_fau',
        icon: '/poap/twitter.svg',
      },
      {
        name: 'steve_fau',
        link: 'https://t.me/steve_fau',
        icon: '/poap/telegram.svg',
      },
      {
        name: 'steve@pwn.xyz',
        link: 'mailto:steve@pwn.xyz',
        icon: '/poap/email.svg',
      },
    ],
    profileImg: getProfileImageByName('Steve Fau'),
  },
])


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, { class: "poap-page__header" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pwnFrontLine), (profile) => {
          return (_openBlock(), _createElementBlock("div", {
            key: profile.name,
            class: "poap-page__profile"
          }, [
            _createElementVNode("img", {
              src: profile.profileImg,
              alt: profile.name,
              class: "poap-page__profile-img"
            }, null, 8, _hoisted_3),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(profile.name), 1),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profile.socials, (social, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: index,
                  href: social.link,
                  target: "_blank",
                  class: "poap-page__profile-social-link"
                }, [
                  (social.icon)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: social.icon,
                        alt: social.name,
                        class: "poap-page__profile-social-img"
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(social.name), 1)
                ], 8, _hoisted_7))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      (_unref(activePoap))
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 0,
            id: "poap-iframe",
            ref_key: "poapIframeRef",
            ref: poapIframeRef,
            title: "POAP iframe",
            class: "poap-page__poap-iframe-filter",
            scrolling: "no",
            loading: "eager",
            width: "100%",
            height: "910",
            src: `https://app.poap.xyz/claim-websites/${_unref(activePoap).poapWebsiteName}`
          }, null, 8, _hoisted_10))
        : _createCommentVNode("", true)
    ]),
    _createVNode(JoinCommunity),
    _createVNode(Footer)
  ]))
}
}

})